import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useRosterManagementReport } from "../../hooks/useRosterManagementReport";
import { useDownloadRosterManagementReportCsv } from "../../hooks/useDownloadRosterManagementReportCsv";
import { rosterManagementReportColumns } from "../RosterManagementReportColumns/RosterManagementReportColumns";
import RosterManagementReportFilters from "../RosterManagementReportFilters/RosterManagementReportFilters";
import { RosterManagementReportItem } from "../../api/fetchRosterManagementReport/types";

const columns = rosterManagementReportColumns();

const RosterManagementReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    filters,
    sessionLabel,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useRosterManagementReport();

  const { loading: csvLoading, downloadCsv } =
    useDownloadRosterManagementReportCsv();

  return (
    <MainPageWrapper title="Roster Management Report">
      <RosterManagementReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
        sessionLabel={sessionLabel}
      />
      <DataTable<RosterManagementReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No roster entries found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default RosterManagementReportPage;
